export enum ScopeApplicationState {
  Draft = 0,
  Submitted = 1,
  Complete = 2,
  Withdrawn = 3
}

export enum ScopeApplicationType {
  Expansion = 0
}

export type ScopeApplicationSummary = {
  id: string;
  type: ScopeApplicationType;
  createdBy: string;
  createdByName: string;
  createdAt: string;
  submittedBy?: string;
  submittedByName?: string;
  submittedAt?: string;
  updatedBy: string;
  updatedByName: string;
  updatedAt: string;
  organisationID: number;
  organisationName: string;
  state: ScopeApplicationState;
  title: string | null;
  assignedToUpn?: string;
  assignedToDisplayName?: string;
  scopesCount: number;
}